(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swap-anim"] && !Shopify.designMode) return;
  try {
    /* Sur téléphone (pas de survol) : démonstration jouée une fois quand la carte arrive à l'écran. */
  (function () {
    if (window.__vimaSwap || !window.IntersectionObserver || !window.matchMedia('(hover: none)').matches) return;
    window.__vimaSwap = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        setTimeout(function () { el.classList.add('is-on'); }, 300);
        setTimeout(function () { el.classList.remove('is-on'); }, 2600);
      });
    }, { threshold: 0.6 });
    var watch = function () { document.querySelectorAll('[data-swap]:not([data-swap-seen])').forEach(function (el) { el.setAttribute('data-swap-seen', ''); io.observe(el); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    /* Cartes ajoutées plus tard (recommandations chargées après coup). */
    if (window.MutationObserver) new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
